import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-document-template-options',
  templateUrl: './document-template-options.component.html',
  styleUrls: ['./document-template-options.component.scss']
})
export class DocumentTemplateOptionsComponent {
  @Output() onCancel = new EventEmitter<void>();
  @Output() onSelectGenerate = new EventEmitter<void>();
  @Output() onSelectUpload = new EventEmitter<File>();
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";


  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      // if (file.type !== 'application/pdf') {
      //   alert('Please upload a valid PDF file');
      //   return;
      // }
      this.onSelectUpload.emit(file); // Emit the file to the parent component
    }
  }

  onSelectGenerateClick() {
    this.onSelectGenerate.emit(); // Notify parent to generate a new quotation
  }

  onCancelClick() {
    this.onCancel.emit();
  }
}
